<template>
  <b-modal
    v-model="showModale"
    ok-only
    :ok-title="$t('Schliessen')"
    ok-variant="btn outline-secondary"
  >
    <div class="text-center">
      <RocketSvg class="rocketBlue" />
      <div>
        <h2 class="my-4">{{ $t('Entschuldigung!') }}</h2>
        <p>
          {{ $t('Aber dieser Link ist nicht mehr gültig.') }}
        </p>
      </div>
    </div>
  </b-modal>
</template>

<script>
import RocketSvg from '../assets/images/Invite.svg'

export default {
  components: {
    RocketSvg,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  data() {
    return {
      showModale: this.show,
    }
  },
}
</script>

<style lang="scss">
@import '../assets/style/vars';

.rocketBlue {
  width: 60px;
  height: 60px;
}

.modal-header,
.modal-footer {
  border: none;
}

.modal-footer {
  margin-right: 10px;
}

.modal-body {
  padding: 0 30px 20px 30px;
}

.modal-dialog {
  max-width: 550px;
}
</style>
